var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreditCardFillpaypg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.75C0 6.72229 0.408258 5.73666 1.13496 5.00996C1.86166 4.28326 2.84729 3.875 3.875 3.875H27.125C28.1527 3.875 29.1383 4.28326 29.865 5.00996C30.5917 5.73666 31 6.72229 31 7.75V9.6875H0V7.75Z",
    fill: "#56B280"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 13.5625V23.25C0 24.2777 0.408258 25.2633 1.13496 25.99C1.86166 26.7167 2.84729 27.125 3.875 27.125H27.125C28.1527 27.125 29.1383 26.7167 29.865 25.99C30.5917 25.2633 31 24.2777 31 23.25V13.5625H0ZM5.8125 17.4375C5.29864 17.4375 4.80583 17.6416 4.44248 18.005C4.07913 18.3683 3.875 18.8611 3.875 19.375V21.3125C3.875 21.8264 4.07913 22.3192 4.44248 22.6825C4.80583 23.0459 5.29864 23.25 5.8125 23.25H7.75C8.26386 23.25 8.75667 23.0459 9.12002 22.6825C9.48337 22.3192 9.6875 21.8264 9.6875 21.3125V19.375C9.6875 18.8611 9.48337 18.3683 9.12002 18.005C8.75667 17.6416 8.26386 17.4375 7.75 17.4375H5.8125Z",
    fill: "#56B280"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardFillpaypg);
export default __webpack_public_path__ + "static/media/CreditCardFillpaypg.6a707840a21b2756761e0904f1c33afe.svg";
export { ForwardRef as ReactComponent };